import { FetchClient } from "../utils/fetchClient"

export const authEmail = async (body) => {
    return FetchClient(`/emails/google/email/auth`).POST({ payload: JSON.stringify(body) })
}

export const confirmEmails = async (body) => {
    return FetchClient(`/emails/google/auth/validate`).POST({ payload: JSON.stringify(body) })
}